export default __webpack_public_path__ + "send_active.ce973600.svg";